import $ from 'jquery';

// Function for switch between tabs
const switchTabs = button => {
  if (button.length === 0) return;

  let tabId = button.data('href'),
    tabs = button.closest('.r-tabs'),
    tabsButton = tabs.find($('.r-tabs__anchor')),
    tabsBody = tabs.find($('.r-tabs__body-content'));

  tabsButton.not(button).removeClass('current');

  tabsBody.not(tabId).removeClass('current');

  button.addClass('current');

  tabs.find(tabId).addClass('current');
};

export { switchTabs };
